import { FunnelSimpleIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface ReportEventsFilteredEmptyStateProps {
    hiddenEventCount: number;
}

export function ReportEventsFilteredEmptyState({
    hiddenEventCount,
}: ReportEventsFilteredEmptyStateProps) {
    const { t } = useTranslation(I18nNamespace.REPORTS);

    return (
        <div className="flex flex-1 items-center justify-center py-16">
            <div className="flex flex-col items-center gap-2 text-center">
                <FunnelSimpleIcon className="w-8 h-8 text-grey-200" />
                <h2 className="text-lg text-grey-200">
                    {t('detail.noVisibleEvents.title')}
                </h2>
                <p className="text-sm text-grey-300">
                    {t('detail.noVisibleEvents.hidden', {
                        count: hiddenEventCount,
                    })}
                </p>
            </div>
        </div>
    );
}
